/* 🔥HA Cart Drawer — Impulse 8.1. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var TIMER_KEY = 'ha-cart-timer';
  var root = null;
  var busy = false;
  var queue = [];
  var lastFocus = null;
  var timerId = null;

  function rootUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function getRoot() {
    var el = document.getElementById('HaCartDrawer');
    if (el && el.parentElement !== document.body) {
      document.body.appendChild(el);
    }
    return el;
  }

  function sectionId() {
    if (!root) return null;
    var id = root.getAttribute('data-section-id');
    if (id) return id;
    var host = root.closest('.shopify-section');
    return host && host.id ? host.id.replace(/^shopify-section-/, '') : null;
  }

  /* ---------- open / close ---------- */
  function open() {
    if (!root) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ha-cart-lock');
    var panel = root.querySelector('.ha-cart__panel');
    if (panel) setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) {} }, 10);
    requestAnimationFrame(sizeTiers);
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ha-cart-lock');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  function isOpen() { return !!(root && root.classList.contains('is-open')); }

  /* ---------- render ---------- */
  function updateBubble(count) {
    document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) { el.innerText = count; });
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', count > 0);
    });
  }

  function swapBody(html) {
    if (!root || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-ha-cart-body]');
    var current = root.querySelector('[data-ha-cart-body]');
    if (!fresh || !current) return;
    var scroller = current.querySelector('.ha-cart__contents');
    var top = scroller ? scroller.scrollTop : 0;
    current.replaceWith(fresh);
    var nextScroller = fresh.querySelector('.ha-cart__contents');
    if (nextScroller) nextScroller.scrollTop = top;
    updateBubble(parseInt(fresh.getAttribute('data-count'), 10) || 0);
    renderTimer();
    sizeTiers();
  }

  function refresh() {
    var id = sectionId();
    if (!id) return Promise.resolve();
    return fetch(rootUrl() + '?sections=' + encodeURIComponent(id), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { swapBody(data && data[id]); })
      .catch(function () {});
  }

  /* Bottom padding of the tier bar = tallest step label + 20px (45px fallback). */
  function sizeTiers() {
    if (!root) return;
    var bar = root.querySelector('[data-ha-cart-tiers]');
    if (!bar) return;
    var labels = bar.querySelectorAll('.ha-cart__step-label');
    var max = 0;
    labels.forEach(function (l) { var h = l.getBoundingClientRect().height; if (h > max) max = h; });
    bar.style.paddingBottom = max > 0 ? (max + 20) + 'px' : '45px';
  }

  /* ---------- cart changes ---------- */
  function setLoading(line, on) {
    if (!root) return;
    var btn = root.querySelector('[data-ha-checkout]');
    if (btn) { btn.classList.toggle('is-loading', on); btn.disabled = on; }
    if (line) {
      line.classList.toggle('is-loading', on);
      line.querySelectorAll('button, input').forEach(function (el) { el.disabled = on; });
    }
  }

  function change(line, qty) {
    if (busy) { queue.push([line, qty]); return; }
    busy = true;
    var key = line.getAttribute('data-ha-line');
    setLoading(line, true);
    fetch(rootUrl() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('ha-cart:changed', { detail: { cart: cart } }));
        return refresh();
      })
      .catch(function () { return refresh(); })
      .then(function () {
        busy = false;
        var next = queue.shift();
        if (next) {
          var fresh = root.querySelector('[data-ha-line="' + next[0].getAttribute('data-ha-line') + '"]');
          if (fresh) change(fresh, next[1]);
        }
      });
  }

  /* ---------- timer ---------- */
  function readTimer() {
    try { var v = sessionStorage.getItem(TIMER_KEY); return v === null ? null : parseInt(v, 10); } catch (e) { return null; }
  }
  function writeTimer(v) {
    try { sessionStorage.setItem(TIMER_KEY, String(v)); } catch (e) {}
  }
  var timerLeft = 0;
  function renderTimer() {
    if (!root) return;
    var bar = root.querySelector('[data-ha-cart-timer]');
    if (!bar) return;
    if (timerLeft <= 0) { bar.hidden = true; return; }
    var m = Math.floor(timerLeft / 60), s = timerLeft % 60;
    var val = bar.querySelector('[data-ha-cart-timer-value]');
    if (val) val.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    bar.hidden = false;
  }
  function startTimer() {
    if (!root || root.getAttribute('data-timer-enabled') !== 'true') return;
    var total = parseInt(root.getAttribute('data-timer-seconds'), 10) || 600;
    var saved = readTimer();
    timerLeft = (saved === null || isNaN(saved) || saved <= 0) ? total : Math.min(saved, total);
    writeTimer(timerLeft);
    renderTimer();
    if (timerId) clearInterval(timerId);
    timerId = setInterval(function () {
      if (timerLeft <= 0) { clearInterval(timerId); timerId = null; renderTimer(); return; }
      timerLeft -= 1;
      writeTimer(timerLeft);
      renderTimer();
    }, 1000);
  }

  /* ---------- events ---------- */
  function onClick(e) {
    if (!root) return;
    var t = e.target;

    var opener = t.closest && t.closest('.js-drawer-open-cart, [data-ha-cart-open]');
    if (opener && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
      refresh();
      return;
    }

    if (!root.contains(t)) return;

    if (t.closest('[data-ha-cart-close]')) { e.preventDefault(); close(); return; }

    var line = t.closest('[data-ha-line]');
    if (!line) return;
    var current = parseInt(line.getAttribute('data-ha-qty'), 10) || 1;
    if (t.closest('[data-ha-qty-plus]')) { e.preventDefault(); change(line, current + 1); return; }
    if (t.closest('[data-ha-qty-minus]')) { e.preventDefault(); change(line, current - 1); return; }
    if (t.closest('[data-ha-remove]')) { e.preventDefault(); change(line, 0); return; }
  }

  function onInputChange(e) {
    var input = e.target.closest && e.target.closest('[data-ha-qty-input]');
    if (!input || !root || !root.contains(input)) return;
    var line = input.closest('[data-ha-line]');
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 1) v = 1;
    if (v === (parseInt(line.getAttribute('data-ha-qty'), 10) || 1)) { input.value = v; return; }
    change(line, v);
  }

  function onKey(e) {
    if (e.key === 'Escape' && isOpen()) close();
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-ha-qty-input]')) {
      e.preventDefault();
      e.target.blur();
    }
  }

  function onAdded(e) {
    if (!root) return;
    e.stopImmediatePropagation();
    refresh().then(function () {
      if (root.getAttribute('data-open-on-add') !== 'false') open();
    });
  }

  function onExternalOpen(e) {
    if (!root) return;
    e.stopImmediatePropagation();
    open();
    refresh();
  }

  function bindOnce() {
    if (window.__haCartBound) return;
    window.__haCartBound = true;
    document.addEventListener('click', onClick, true);
    document.addEventListener('change', onInputChange, true);
    document.addEventListener('keydown', onKey);
    document.addEventListener('ajaxProduct:added', onAdded, true);
    document.addEventListener('cart:open', onExternalOpen, true);
    document.addEventListener('ha-cart:open', function () { open(); refresh(); });
    document.addEventListener('ha-cart:refresh', function () { refresh(); });
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) { refresh(); } });
    document.addEventListener('shopify:section:load', function (ev) {
      var fresh = document.getElementById('HaCartDrawer');
      if (!fresh) return;
      document.querySelectorAll('body > #HaCartDrawer').forEach(function (old) { if (old !== fresh) old.remove(); });
      init();
    });
    document.addEventListener('shopify:section:select', function (ev) {
      if (root && ev.detail && ev.detail.sectionId === root.getAttribute('data-section-id')) { open(); refresh(); }
    });
    document.addEventListener('shopify:section:deselect', function (ev) {
      if (root && ev.detail && ev.detail.sectionId === root.getAttribute('data-section-id')) close();
    });
  }

  function init() {
    root = getRoot();
    if (!root) return;
    bindOnce();
    startTimer();
    sizeTiers();
    window.HaCart = { open: open, close: close, refresh: refresh };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
